<template>
  <div ref="overlay" :class="overlay_class" :style="overlay_style">
    <slot v-if="show_default"></slot><slot v-else name="overlay"></slot>
  </div>
</template>

<script>
import _ from 'lodash'
import $ from 'jquery'

import Vue from 'vue'
import { mapState } from 'vuex'

// *****************************************************************************

export default {
  name: 'FileExplorer',
  props: ['overlay'],
  data() {
    return { initialized: false, height: 0, width: 0 }
  },

  computed: {
    show_default() {
      return !(this.initialized && this.overlay)
    },
    overlay_class() {
      let res
      if (!this.show_default) {
        res = [
          'd-flex',
          'flex-row',
          'justify-content-center',
          'align-items-center',
        ]
      }
      return res
    },
    overlay_style() {
      let res
      if (!this.show_default) {
        res = {
          width: `${this.width}px`,
          height: `${this.height}px`,
        }
      }
      return res
    },
  },
  watch: {
    overlay(nv, ov) {
      if (!this.initialized && nv && nv !== ov) {
        let overlay = $(this.$refs.overlay)
        this.width = overlay.width()
        this.height = overlay.height()
        this.initialized = true
      }
    },
  },
}
</script>
